const newsItemTemplate = document.createElement('template')

newsItemTemplate.innerHTML = `
  <div class="card news-element">
    <div class="card-img">
      <div class="news-image overlay-image">
        <picture class="img-fluid w-100 news-image-picture">
          <img class="img-fluid w-100 news-teaser-image"
              src=""
              loading="lazy" />
        </picture>
        <div class="overlay"></div>
      </div>
      <span class="badge news-category"></span>
    </div>

    <div class="card-body">
      <div class="card-title">
        <h5 class="news-title"></h5>
      </div>
      <p class="card-text small news-teaser"></p>
      <div class="card-links">

        <a class="color-text small stretched-link news-readmore" title="Weiterlesen" href="">
          Weiterlesen
          <span class="svg-icon">
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 32 32" style="enable-background:new 0 0 32 32;" xml:space="preserve">
              <polygon points="22,16 12,26 10.6,24.6 19.2,16 10.6,7.4 12,6 "></polygon>
              <rect class="fill-none" width="32" height="32"></rect>
            </svg>
          </span>
        </a>

      </div>
    </div>
  </div>
`

class NewsCard extends HTMLElement {
  constructor(
    categories: string,
    image: string,
    link: string,
    tags: string,
    teaser: string,
    title: string
  ) {
    super()
    this.appendChild(newsItemTemplate.content.cloneNode(true))
    this.classList.add('col-xxl-3', 'col-xl-6', 'news-col')
    // if current slug contains /de/ we use artikel/{url} else we use article/{url}
    const currentSlug = window.location.pathname.split('/')[1]

    const badge = this.querySelector('.news-category') as HTMLElement
    const img = this.querySelector('.news-teaser-image') as HTMLImageElement
    const titleElement = this.querySelector('.news-title') as HTMLElement
    const linkElement = this.querySelector(
      '.news-readmore'
    ) as HTMLAnchorElement
    const teaserElement = this.querySelector('.news-teaser') as HTMLElement
    //const tagsElement = this.querySelector('.news-primary-tag') as HTMLElement
    badge
      ? (badge.innerText = this.getAttribute('categories') || categories)
      : null
    img ? (img.src = this.getAttribute('image') || image) : null
    titleElement
      ? (titleElement.innerText = this.getAttribute('title') || title)
      : null
    linkElement
      ? (linkElement.href =
          this.getAttribute('link') || currentSlug === 'de'
            ? '/de/news-stories/artikel/' + link
            : '/en/news-stories/article/' + link)
      : null
    teaserElement
      ? (teaserElement.innerText = this.getAttribute('teaser') || teaser)
      : null
    /*
    tagsElement
      ? (tagsElement.innerText = this.getAttribute('tags') || tags)
      : null
    */
  }
  connectedCallback() {
    this.render()
  }

  render() {}
}

export default NewsCard
